module.exports = __webpack_public_path__ + "static/3_2_Bayes-Rule_1_FR-8ffef6525019d523d1075bae7bd6ac6f.svg";